import XLSX from 'xlsx-add-style';
import { format } from 'date-fns';
import wlCnpj from './wlCnpj.json';
import { formatIdentity } from './index';

export function excelGenerator (title = '', sheetName = '', filename = '', before = [], after = [], cols = [], rows = [], mergeAfter = false) {
	if(window.location.pathname === '/detalhe-conta-grafica' || window.location.pathname === '/extrato-pix'){
		let newArg = ["whitelabel = ''"]
		newArg.push(arguments[8])
	}
	const wb = XLSX.utils.book_new();

	wb.Props = {
		Title: sheetName,
		Subject: sheetName,
		Author: process.env.VUE_APP_TITLE,
		CreatedDate: new Date(),
	};

	wb.SheetNames.push(sheetName);

	const counter = cols.map(col => { return col.toString().length });

	rows.forEach(row => {
		let index = 0;
		Object.values(row).forEach(item => {
			if (item.v) {
				if (item.v.toString().length > counter[index]) {
					counter[index] = item.v.toString().length;
				}
			}
			if (item) {
				if (item.toString().length > counter[index]) {
					counter[index] = item.toString().length;
				}

				if (after[0].length !== 0) {
					if (after[0][index]) {
						if (after[0][index].v) {
							if (after[0][index].v.toString().length > counter[index]) {
								counter[index] = after[0][index].v.toString().length
							}
						}
					}
				}
			}
			index++;
		})
	});

	const colsWidth = counter.map(wid => {
		return {
			wch: wid + 2
		};
	});

	const dataC = cols.map(item => {
		return {
			v: item,
			t: 's',
			s: {
				font: {
					bold: true
				},
				fill: {
					patternType: 'solid',
					fgColor: {
						rgb: 'ffF5F5F5',
					},
					bgColor: {
						rgb: 'ffF5F5F5',
					},
				},
				border: {
					top: { style: 'thin', color: { rgb: 'ffcecece' } },
					right: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
					bottom: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
					left: { style: 'thin', color: { rgb: 'ffcecece' } },
				},
			},
		};
	});

	const dataR = rows.map(item => {
		return Object.values(item);
	});

	const ws_data = [
		[
			{
				v: arguments[8] ?  `${title} / ${arguments[8].toUpperCase()} - ${formatIdentity(wlCnpj.data[arguments[8]].cnpj)}` : `${title} / ${process.env.VUE_APP_TITLE} `,
				t: 's',
				s: {
					fill: {
						patternType: "solid", // none / solid
						fgColor: { rgb: 'ff' + process.env.VUE_APP_PRIMARY_COLOR.replace('#', '') },
					},
					font: { sz: 14, color: { rgb: "ffffffff" }, },
					alignment: { horizontal: 'center' },
				},
			},
		],
		[],
	]


	if (before[0].length !== 0) {
		ws_data.push(...before);
		ws_data.push([]);
	}

	const newCol = dataC.filter(item => item.v !== 'notRender')
	const newRow = dataR.map(item => item.filter(item => item !== 'notRender'))
	ws_data.push(newCol);
	ws_data.push(...newRow);

	if (after[0].length !== 0) {
		const newAfter = after[0].map(row => {
			if (!row.v) {
				row.v = '';
				row.t = 's';
				row.s = {
					alignment: { horizontal: 'left' },
					font: { bold: true },
					fill: {
						patternType: 'solid',
						fgColor: {
							rgb: 'fff5f5f5',
						},
						bgColor: {
							rgb: 'fff5f5f5',
						},
					},
					border: {
						top: {
							style: 'thin',
							color: { rgb: 'ffcecece' },
						},
						right: {
							style: 'thin',
							color: { rgb: 'ffcecece' },
						},
						bottom: {
							style: 'thin',
							color: { rgb: 'ffcecece' },
						},
						left: {
							style: 'thin',
							color: { rgb: 'ffcecece' },
						},
					},
				}
			}
			return row;
		})

		ws_data.push([]);
		ws_data.push(newAfter);
	}

	let ws = XLSX.utils.aoa_to_sheet(ws_data);

	const merge = [
		{ s: { r: 0, c: 0 }, e: { r: 0, c: cols.length - 1 } },
	];

	const letters = ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O'];

	let salt = 0;

	if (before[0].length !== 0) {
		before.forEach(item => {
			if (item.length !== 0) {
				salt = salt + 2;
				merge.push({ s: { r: salt, c: 0 }, e: { r: salt, c: cols.length - 1 } });

				letters.forEach(lt => {
					ws[`${lt}${salt + 1}`] = {
						t: 's',
						v: '',
						s: {
							border: {
								top: { style: 'thin', color: { rgb: 'ffcecece' } },
								right: {
									style: 'thin',
									color: { rgb: 'ffcecece' },
								},
								bottom: {
									style: 'thin',
									color: { rgb: 'ffcecece' },
								},
								left: { style: 'thin', color: { rgb: 'ffcecece' } },
							}
						}
					};
				});
			}
		});
	}

	if (mergeAfter) {
		if (after[0].length !== 0) {
		after.forEach(item => {
			if (item.length !== 0) {
				merge.push({ s: { r: salt + rows.length + 4, c: 0 }, e: { r: salt + rows.length + 4, c: cols.length - 1 } });

				letters.forEach(lt => {
					ws[`${lt}${salt + rows.length + 5}`] = {
						t: 's',
						v: '',
						s: {
							border: {
								top: { style: 'thin', color: { rgb: 'ffcecece' } },
								right: {
									style: 'thin',
									color: { rgb: 'ffcecece' },
								},
								bottom: {
									style: 'thin',
									color: { rgb: 'ffcecece' },
								},
								left: { style: 'thin', color: { rgb: 'ffcecece' } },
							}
						}
					};
				});

				salt = salt + 2;
			}
		})
	}
	}

	ws['!merges'] = merge;

	ws['!cols'] = colsWidth;

	ws['!rows'] = [{hpt: 17},]

	wb.Sheets[sheetName] = ws;

	const now = format(new Date(), 'dd/MM/yyyy HH:mm:ss');

	XLSX.writeFile(wb, `${filename}_${now}.xlsx`);
}
